module.exports = __webpack_public_path__ + "fonts/WorkSans-Roman-VariableFont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/WorkSans/WorkSans-Roman-VariableFont.ttf
// module id = 3486
// module chunks = 0